import * as moment from 'moment';
import 'moment/locale/is';

export default {
	ordflokkar: {
		'v': 'sagnorð',
		'n': 'nafnorð',
		'pron': 'fornafn',
		'adv': 'atviksorð',
		'adj': 'lýsingarorð',
		'rel': 'tilvísunartenging',
		'int': 'upphrópun',
		'conj': 'samtenging',
		'al': 'óflokkað',
		'art': 'greinir',
		'inf': 'nafnháttarmerki',
		'num': 'töluorð',
		'abbr': 'skammstöfun',
		'?': 'óþekkt',
		'fv': 'fv',
	},

	tungumal: {
		'en': 'Enska',
		'da': 'Danska',
		'no': 'Norska',
		'nb': 'Norska (Bokmål)',
		'sv': 'Sænska',
		'de': 'Þýska',
		'aa': 'Afar',
		'ab': 'Abkhazian',
		'ae': 'Avestan',
		'af': 'Afrikaans',
		'ak': 'Akan',
		'am': 'Amharic',
		'an': 'Aragonese',
		'ar': 'Arabic',
		'as': 'Assamese',
		'av': 'Avaric',
		'ay': 'Aymara',
		'az': 'Azerbaijani',
		'ba': 'Bashkir',
		'be': 'Belarusian',
		'bg': 'Bulgarian',
		'bh': 'Bihari languages',
		'bi': 'Bislama',
		'bm': 'Bambara',
		'bn': 'Bengali',
		'bo': 'Tibetan',
		'br': 'Breton',
		'bs': 'Bosnian',
		'ca': 'Catalan; Valencian',
		'ce': 'Chechen',
		'ch': 'Chamorro',
		'co': 'Corsican',
		'cr': 'Cree',
		'cs': 'Czech',
		'cu': 'Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic',
		'cv': 'Chuvash',
		'cy': 'Welsh',
		'cy': 'Welsh',
		'dv': 'Divehi; Dhivehi; Maldivian',
		'dz': 'Dzongkha',
		'ee': 'Ewe',
		'el': 'Greek, Modern (1453-)',
		'el': 'Greek, Modern (1453-)',
		'eo': 'Esperanto',
		'es': 'Spanish; Castilian',
		'et': 'Estonian',
		'eu': 'Basque',
		'eu': 'Basque',
		'fa': 'Persian',
		'ff': 'Fulah',
		'fi': 'Finnish',
		'fj': 'Fijian',
		'fo': 'Faroese',
		'fr': 'French',
		'fr': 'French',
		'fy': 'Western Frisian',
		'ga': 'Irish',
		'gd': 'Gaelic; Scottish Gaelic',
		'gl': 'Galician',
		'gn': 'Guarani',
		'gu': 'Gujarati',
		'gv': 'Manx',
		'ha': 'Hausa',
		'he': 'Hebrew',
		'hi': 'Hindi',
		'ho': 'Hiri Motu',
		'hr': 'Croatian',
		'ht': 'Haitian; Haitian Creole',
		'hu': 'Hungarian',
		'hy': 'Armenian',
		'hy': 'Armenian',
		'hz': 'Herero',
		'ia': 'Interlingua (International Auxiliary Language Association)',
		'id': 'Indonesian',
		'ie': 'Interlingue; Occidental',
		'ig': 'Igbo',
		'ii': 'Sichuan Yi; Nuosu',
		'ik': 'Inupiaq',
		'io': 'Ido',
		'is': 'Icelandic',
		'it': 'Italian',
		'iu': 'Inuktitut',
		'ja': 'Japanese',
		'jv': 'Javanese',
		'ka': 'Georgian',
		'ka': 'Georgian',
		'kg': 'Kongo',
		'ki': 'Kikuyu; Gikuyu',
		'kj': 'Kuanyama; Kwanyama',
		'kk': 'Kazakh',
		'kl': 'Kalaallisut; Greenlandic',
		'km': 'Central Khmer',
		'kn': 'Kannada',
		'ko': 'Korean',
		'kr': 'Kanuri',
		'ks': 'Kashmiri',
		'ku': 'Kurdish',
		'kv': 'Komi',
		'kw': 'Cornish',
		'ky': 'Kirghiz; Kyrgyz',
		'la': 'Latin',
		'lb': 'Luxembourgish; Letzeburgesch',
		'lg': 'Ganda',
		'li': 'Limburgan; Limburger; Limburgish',
		'ln': 'Lingala',
		'lo': 'Lao',
		'lt': 'Lithuanian',
		'lu': 'Luba-Katanga',
		'lv': 'Latvian',
		'mg': 'Malagasy',
		'mh': 'Marshallese',
		'mi': 'Maori',
		'mi': 'Maori',
		'mk': 'Macedonian',
		'ml': 'Malayalam',
		'mn': 'Mongolian',
		'mr': 'Marathi',
		'ms': 'Malay',
		'ms': 'Malay',
		'mt': 'Maltese',
		'my': 'Burmese',
		'na': 'Nauru',
		'nd': 'Ndebele, North; North Ndebele',
		'ne': 'Nepali',
		'ng': 'Ndonga',
		'nl': 'Dutch; Flemish',
		'nr': 'Ndebele, South; South Ndebele',
		'nv': 'Navajo; Navaho',
		'ny': 'Chichewa; Chewa; Nyanja',
		'oc': 'Occitan (post 1500)',
		'oj': 'Ojibwa',
		'om': 'Oromo',
		'or': 'Oriya',
		'os': 'Ossetian; Ossetic',
		'pa': 'Panjabi; Punjabi',
		'pi': 'Pali',
		'pl': 'Polish',
		'ps': 'Pushto; Pashto',
		'pt': 'Portuguese',
		'qu': 'Quechua',
		'rm': 'Romansh',
		'rn': 'Rundi',
		'ro': 'Romanian; Moldavian; Moldovan',
		'ru': 'Russian',
		'rw': 'Kinyarwanda',
		'sa': 'Sanskrit',
		'sc': 'Sardinian',
		'sd': 'Sindhi',
		'se': 'Northern Sami',
		'sg': 'Sango',
		'si': 'Sinhala; Sinhalese',
		'sk': 'Slovak',
		'sl': 'Slovenian',
		'sm': 'Samoan',
		'sn': 'Shona',
		'so': 'Somali',
		'sq': 'Albanian',
		'sq': 'Albanian',
		'sr': 'Serbian',
		'ss': 'Swati',
		'st': 'Sotho, Southern',
		'su': 'Sundanese',
		'sw': 'Swahili',
		'ta': 'Tamil',
		'te': 'Telugu',
		'tg': 'Tajik',
		'th': 'Thai',
		'ti': 'Tigrinya',
		'tk': 'Turkmen',
		'tl': 'Tagalog',
		'tn': 'Tswana',
		'to': 'Tonga (Tonga Islands)',
		'tr': 'Turkish',
		'ts': 'Tsonga',
		'tt': 'Tatar',
		'tw': 'Twi',
		'ty': 'Tahitian',
		'ug': 'Uighur; Uyghur',
		'uk': 'Ukrainian',
		'ur': 'Urdu',
		'uz': 'Uzbek',
		've': 'Venda',
		'vi': 'Vietnamese',
		'vo': 'Volapük',
		'wa': 'Walloon',
		'wo': 'Wolof',
		'xh': 'Xhosa',
		'yi': 'Yiddish',
		'yo': 'Yoruba',
		'za': 'Zhuang; Chuang',
		'zh': 'Chinese',
		'zh': 'Chinese',
		'zu': 'Zulu',
	},

	capitalizeFirstLetter(string) {
		return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
	},


	validateEmail(email) {
		//var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		return re.test(String(email).toLowerCase());
	},

	formatDate(date, hideTime) {
		var formated = moment(date);
		formated.locale('is')

		return formated.format(hideTime ? 'LL' : 'LLL');
	}
}


// WEBPACK FOOTER //
// ./src/nyyrdiHelper.js